import React, { useMemo, useState } from 'react';
import clsx from 'clsx';

/**
 * 동행복권의 경우 번호는 제공하지 않아 별도로 구성
 */
const DhRoundTable = ({ list = [], title = '회차별 통계' }) => {
  const size = 10;
  const [page, setPage] = useState(1);
  const totalPage = useMemo(() => {
    if (list.length === 0) return 1;
    return Math.ceil(list.length / size);
  }, [list.length]);

  return (
    <div className="data_list_wrap">
      <h3 className="tit">{title}</h3>
      <div className="data_list">
        <div className="table_float">
          <table className="list" border="1">
            <caption>결과리스트</caption>
            <colgroup>
              <col width="74px" />
            </colgroup>
            <thead>
              <tr>
                <th>회차</th>
              </tr>
            </thead>
            <tbody>
              {list.slice(0, size * page).map((item, key) => {
                return (
                  <tr key={key}>
                    <td>{`${item.date_round} (${item.round})`}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="table_data powerball dhlottery">
          <table className="list" border="1">
            <caption>결과리스트</caption>
            <thead>
              <tr>
                <th colSpan="2">일반볼합</th>
                <th >파워볼</th>
              </tr>
              <tr>

                <th>홀짝</th>
                <th>대중소</th>
                <th>언오버</th>
              </tr>
            </thead>
            <tbody>
              {list.slice(0, size * page).map((item, key) => {
                return (
                  <tr key={key}>

                    <td>
                      <span className={clsx('ic', item.sum_odd_even)}>
                        {item.sum_odd_even === 'ODD' ? '홀' : '짝'}
                      </span>
                    </td>
                    <td>
                      <span className={clsx('ic', item.sum_size)}>
                        {item.sum_size === 'L'
                          ? '대'
                          : item.sum_size === 'M'
                            ? '중'
                            : '소'}
                      </span>
                    </td>
                    <td>
                      <span className={clsx('ic', item.powerball_unover)}>
                        {item.powerball_unover === 'OVER' ? '오버' : '언더'}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <button
        className="btn_more"
        style={page === totalPage ? { display: 'none' } : {}}
        onClick={() => {
          if (page >= totalPage) return;
          setPage(page + 1);
        }}
      >
        더보기 ( {page} / {totalPage} )
      </button>
    </div>
  );
};

export default DhRoundTable;
